import React from 'react';

export default function Vegetables() {
  return <div>Vegetables</div>;
}
